// state is not the application state, only the state this
// reducer is responsible for.
import { LATLON_QUERY } from "../constants/ActionTypes";

// Returns a Clue object
export default function (state = null, action) {

   switch (action.type) {
      case LATLON_QUERY:
         return action.payload;
      default:
         return state;
   }
}


// WEBPACK FOOTER //
// ./src/reducers/reducer_latlon.js